export enum ProgressBarVariants {
  Striped = 'striped',
  Thin = 'thin',
  ThinLight = 'thin-light',
}
